module.exports = __webpack_public_path__ + "img/bj／pic.4f3972d7.png";